/* @flow */

import QuickLinks from "./QuickLinks.web";

export default QuickLinks;
